import { lsGetOfferGuid, lsRemoveOfferGuid, lsSetOfferGuid } from 'helpers/store';
import { OFFER_STATUS, OFFER_COOKIE_TO_PAGE } from 'store/enums';
import {
  OFFER_INCREMENT_STEP,
  OFFER_DECREMENT_STEP,
  OFFER_SET_CURRENT_STEP,
  OFFER_INIT_GUID,
  OFFER_INIT_WITH_IDOFFER_IDC,
  OFFER_UPDATE_PARAMS,
  OFFER_CHECK_GUID,
  OFFER_COOKIE_SUCCESS,
  OFFER_OPERATION_BY_GUID,
  OFFER_CAMPAIGN_BY_ID,
  OFFER_CAMPAIGN_BY_GUID,
  OFFER_OPERATION_CAMPAIGN_JOIN,
  OFFER_UPDATE_FROM_GUID,
  OFFER_COMPLETED,
  OFFER_REGISTER_SIGNATURE,
  OFFER_UPDATE_PARTNERID
} from 'store/actions/offer';

export default {
  [OFFER_INCREMENT_STEP]: ({ commit }) => commit(OFFER_INCREMENT_STEP),

  [OFFER_DECREMENT_STEP]: ({ commit }) => commit(OFFER_DECREMENT_STEP),

  [OFFER_SET_CURRENT_STEP]: ({ commit }, currentStep) =>
    commit(OFFER_SET_CURRENT_STEP, currentStep),

  [OFFER_UPDATE_PARAMS]: ({ commit }, params) => {
    commit(OFFER_UPDATE_PARAMS, params);
  },

  [OFFER_INIT_WITH_IDOFFER_IDC]: ({ commit, dispatch }, params) => {
    commit(OFFER_UPDATE_PARAMS, params);
    return dispatch(OFFER_CAMPAIGN_BY_ID);
  },

  [OFFER_INIT_GUID]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      const guid = lsGetOfferGuid();
      const guidURL = params.guid;
      commit(OFFER_UPDATE_PARAMS, params);
      dispatch(OFFER_CAMPAIGN_BY_GUID, guidURL)
        .then(() => {
          if (guid && guidURL && guid === guidURL) {
            dispatch(OFFER_CHECK_GUID, guidURL)
              .then(res => resolve(res))
              .catch(() => reject());
          } else {
            resolve();
          }
        })
        .catch(() => reject());
    }),

  [OFFER_COMPLETED]: ({ commit, dispatch }, { params, query }) =>
    new Promise((resolve, reject) => {
      const guid = params.guid || lsGetOfferGuid();
      commit(OFFER_UPDATE_PARAMS, { guid });
      Promise.all([dispatch(OFFER_OPERATION_BY_GUID, guid), dispatch(OFFER_CAMPAIGN_BY_GUID, guid)])
        .then(resp => {
          const { partnerId } = resp[0];
          commit(OFFER_UPDATE_PARTNERID, { partnerId });
          const paramsToRegister = query;
          paramsToRegister.gvGuid = guid;
          dispatch(OFFER_REGISTER_SIGNATURE, paramsToRegister)
            .then(data => {
              const cookieToPage = OFFER_COOKIE_TO_PAGE[data.desStatus.toString().toLowerCase()];
              commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
              resolve({ routerName: cookieToPage.routerName, url: data.url });
            })
            .catch(() => reject());
        })
        .catch(() => reject());
    }),

  [OFFER_OPERATION_CAMPAIGN_JOIN]: ({ dispatch, getters }, guid) =>
    new Promise((resolve, reject) => {
      dispatch(OFFER_OPERATION_BY_GUID, guid)
        .then(() => {
          if (!getters.hasOffer) {
            dispatch(OFFER_CAMPAIGN_BY_ID)
              .then(() => resolve())
              .catch(() => reject());
          } else {
            resolve();
          }
        })
        .catch(() => reject());
    }),

  [OFFER_UPDATE_FROM_GUID]: ({ commit, dispatch }, { data, guid, cookie }) =>
    new Promise((resolve, reject) => {
      commit(OFFER_COOKIE_SUCCESS, data);
      if (OFFER_STATUS.OK === data.idStatus) {
        const newGuid = data.guid ? data.guid : guid;
        if (newGuid) lsSetOfferGuid(newGuid);
        const desStatus = data.desStatus.toString().toLowerCase();
        const cookieToPage =
          OFFER_COOKIE_TO_PAGE[desStatus === '6' && cookie ? `${desStatus}bbva` : desStatus];
        commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
        if (cookieToPage.step === 1) {
          resolve(cookieToPage.routerName);
        } else {
          dispatch(OFFER_OPERATION_CAMPAIGN_JOIN, newGuid || lsGetOfferGuid())
            .then(() => resolve({ routerName: cookieToPage.routerName, url: data.url }))
            .catch(() => reject());
        }
      } else {
        lsRemoveOfferGuid();
        resolve();
      }
    })
};
